<template>
    <path d="M0,50 h25" fill="none" />
    <path d="M25,50 l25,-10 a10 10 0 0 1 0 20" fill="none" />
    <path d="M25,50 l50,20 a10 10 0 0 0 0 -20" fill="none" />
    <path d="M50,60 l50,-20 a10 10 0 0 1 0 20" fill="none" />
    <path d="M75,50 l50,20 a10 10 0 0 0 0 -20" fill="none" />
    <path d="M100,60 l25,-10 h25" fill="none" />
</template>